module.exports = __webpack_public_path__ + "media/icons/widget-download-google-play@2x-ad4ea822.png";